<template>
  <bar-chart :key="componentKey" />
</template>

<script>
import BarChart from '@/components/BarChart'

export default {
  name: 'bar',

  components: {
    BarChart
  },

  data: () => ({
    timer: '',
    componentKey: 0
  }),

  created () {
    this.loaded = false

    this.forceRerender()
    this.timer = setInterval(this.forceRerender, 5 * 60 * 1000)
  },

  methods: {
    forceRerender() {
      this.componentKey += 1;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Bar.vue